import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const fetchSubscribedEmails = async () => {
  const response = await axiosInstance.get("user/email-subscribe", { headers });
  return response.data;
};

export const deleteSubscribedEmail = async (id) => {
  return await axiosInstance.delete(`user/email-subscribe/${id}`, { headers });
};
